import {createStore, applyMiddleware, compose} from 'redux';
import thunkMiddleware from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import {window} from 'ssr-window';
import StorageUtils from '@spothero/utils/storage';
import createHistory from 'utils/history';
import Config from 'config';
import {dataLoadPending} from 'router/router-actions';
import {analyticsMiddleware} from './middleware/analytics';
import {routerMiddleware} from './middleware/router';
import {searchRequestMiddleware} from './middleware/search-request';
import {reduxLoggerMiddleware} from './middleware/redux-logger';
import {experimentMiddleware} from './middleware/experiment';
import reducers from './reducers';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line no-underscore-dangle
const history = createHistory({
    basename: Config.basename,
});
const middlewares = [
    routerMiddleware(history),
    thunkMiddleware,
    promiseMiddleware,
    experimentMiddleware,
    analyticsMiddleware,
    searchRequestMiddleware,
];
let store;

// listen for history events and use this to do proper data loading while routing. unfortunately just calling a history action
// through code does not work the same as using a react router Link or hitting back/forward because those don't route through
// the middleware rather call this history object directly. this allows us to catch all routing and handle data loading at the
// correct time before a new route is actually navigated to (dataLoadPending will fire off an event that shows the loader).
history.listen((location, action) => {
    // ignore the REPLACE action because that's usually just us cleaning up URLs on search and checkout
    if (store && action !== 'REPLACE') {
        store.dispatch(
            dataLoadPending({
                historyAction: action,
                location,
            })
        );
    }
});

if (StorageUtils.get('sh-debug-logger', 'cookie')) {
    middlewares.push(reduxLoggerMiddleware);
}

export default function create(initialState) {
    store = createStore(
        reducers,
        initialState,
        composeEnhancers(applyMiddleware(...middlewares))
    );

    return store;
}

export const getStore = () => {
    return store;
};

export const getHistory = () => {
    return history;
};
